export default __webpack_public_path__ + "static/media/0.82216735.png";